export const DEFAULT_DELAY_TIMEOUT = 10000;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const MAX_DELAY_TIMEOUT = 30000;
